import React, { useEffect, useState } from "react";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import { INITPAGING, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CheckBox from "../based/inputs/CheckBox";
import VideoServices from "../based/services/VideoServices";
import { AfterEffectModel, AfterEffectStatus } from "../preset/PresetModel";
import AddOrEditModal from "./AddOrEditModal";

function AfterEffect(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState("Đang tải...");
    const [datas, setDatas] = useState([AfterEffectModel]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isShowModal, setIsShowModal] = useState(false);
    const [selectId, setSelectId] = useState(0);

    useEffect(() => {
        _getData({ ...INITPAGING });
    }, []);

    async function _getData(paging) {
        setIsBusy(true);
        let [err, data] = await VideoServices.GetAfterEffectByPage(paging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging({ ...INITPAGING });
        }
        setIsBusy(false);
    }

    const handleSortColumn = (columnName) => {
        let dir = "asc";
        if (columnName == paging.orderBy) dir = paging.orderDirection == "desc" ? "asc" : "desc";
        let newPaging = {
            ...paging,
            orderBy: columnName,
            orderDirection: dir,
        };
        _getData(newPaging);
    };

    const _handleChecked = (index, value) => {
        let newDatas = [...datas];
        if (value) setSelectId(newDatas[index].id);
        else setSelectId(0);
    };

    const _handleDelete = async (id) => {
        let selectItem = datas.find((x) => x.id == id);
        if (selectItem && selectItem.status == AfterEffectStatus.Uploaded) {
            Notify(NOTIFY.WARNING, "Có lỗi", "Không thể xóa file đang được xử lý.");
            return;
        }

        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa ", () => {
            return new Promise(async (resolve, reject) => {
                setIsLoading(true);
                setMsg("Đang xóa dữ liệu...");
                let [error, data] = await VideoServices.DeleteAfterEffectById(id);
                if (!error && data) {
                    _getData(paging);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                    reject({ title: "Thất bại", msg: "Vui lòng thử lại sau." });
                }
                setMsg(null);
                setIsLoading(false);
            });
        });
    };

    function _renderHeader() {
        let icon = <i className="fa fa-sort fa-sort-thead"></i>;
        return (
            <thead>
                <tr>
                    <th className="center"></th>
                    <th className="center">Id</th>
                    <th className="center" onClick={() => handleSortColumn("name")}>
                        Tên {paging.orderBy === "name" && paging.orderDirection.toUpperCase() === "DESC" ? <i className="fa fa-sort-desc fa-sort-thead"></i> : paging.orderBy === "name" ? <i className="fa fa-sort-asc fa-sort-thead"></i> : icon}
                    </th>
                    <th className="center">Loại Video</th>
                    <th className="center">Dòng sản phẩm</th>
                    <th className="center">Giới tính</th>
                    <th className="center">Màu</th>
                    <th className="center">Mặt in</th>
                    <th className="center">Số layer</th>
                    <th className="center">Ngày cập nhập</th>
                    <th className="center">Trạng thái</th>
                    <th className="center">Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderAction() {
        let dataChecked = null;
        let isEnabled = false;
        if (datas && datas.length > 0) {
            dataChecked = datas.filter((x) => x.selected);
            if (dataChecked && dataChecked.length == 1) isEnabled = true;
        }
        return (
            <React.Fragment>
                <button
                    className="btn btn-custom"
                    onClick={() => {
                        setIsShowModal(true);
                        setSelectId(0);
                    }}
                >
                    Tải File Lên
                </button>
                <button className={selectId > 0 ? "btn btn-danger ml-3" : "btn btn-danger ml-3 disable"} onClick={() => (selectId > 0 ? _handleDelete(selectId) : {})}>
                    Xóa
                </button>
            </React.Fragment>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr className={idx}>
                                <td>
                                    <CheckBox id={idx.toString()} name={idx.toString()} checked={item.id ? item.id == selectId : false} label=" " onCheckedChange={(name, value) => _handleChecked(idx, value)} />
                                </td>
                                <td className="center">{item.id}</td>
                                <td className="center">{item.name}</td>
                                <td className="center">{item.videoTypeName}</td>
                                <td className="center">{item.appProductName}</td>
                                <td className="center">{item.sexName}</td>
                                <td className="center">{
                                    item.appProductColor ? 
                                    <div> {item.appProductColor}{" "}
                                    <span style={{width: 50, height: 20, background: item.appProductColor}}></span>
                                   </div> : ""
                                }
                                   
                                </td>
                                <td className="center">{item.printSideName}</td>
                                <td className="center">{item.layerCount}</td>
                                <td className="center">{item.createdDate ? Common.formatDate(new Date(item.createdDate)) : ""}</td>
                                <td className="center">
                                    <span className={item.status == AfterEffectStatus.Uploaded ? "badge badge-danger" : item.status == AfterEffectStatus.ProcessedLayerName ? "badge badge-success" : "badge badge-warning"}>{item.statusName}</span>{" "}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-custom"
                                        onClick={() => {
                                            setIsShowModal(true);
                                            setSelectId(item.id);
                                        }}
                                    >
                                        Chi tiết
                                    </button>

                                    <button
                                        className="btn btn-custom ml-3"
                                        onClick={() => {
                                            if (item.status != AfterEffectStatus.Uploaded) {
                                                window.open("/af-config/" + item.id, "_blank");
                                            } else {
                                                Notify(NOTIFY.WARNING, "Có lỗi", "Chỉ file có thông tin layer mới có thể chỉnh sửa thông tin.");
                                            }
                                        }}
                                    >
                                        Chỉnh sửa thông tin
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={999}>Không có dữ liệu</td>
                    </tr>
                )}
            </tbody>
        );
    }

    const _renderNote = () => {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Ghi chú</label>
                            <div className="">
                                - File Upload là File .rar <br />- File .rar nên được collect từ chức năng của After Effect (File {">"} Dependencies {">"} Collect Files)
                                <br />
                                - File After Effect phải là file .aep <br />- File After Effect phải có Composition chính là{" "}
                                <strong
                                    className="cursor-pointer"
                                    onClick={() => {
                                        navigator.clipboard.writeText("__MAIN__");
                                        Notify(NOTIFY.SUCCESS, "Thành công", "Đã copy vào clipboard");
                                    }}
                                >
                                    __MAIN__
                                </strong>
                                <br />
                                - Các trạng thái của file bao gồm:
                                <br />
                                <span className="text-danger">Đã Upload</span>: File đã được upload, chờ xử lý Layer Name
                                <br />
                                <span className="text-success">Đã xử lý Layer Name</span>: File đã được xử lý Layer Name xong, có thể tiến hành config thông tin Layer
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <React.Fragment>
            <Loading show={isBusy} msg="Đang tải dữ liệu..." />
            <Breadcrumbs currentPage="Quản lý After Effect" />
            {_renderNote()}
            <CommonTable datas={datas} paging={paging} searchBasic onFilter={(paging) => _getData(paging)} renderAction={() => _renderAction()} renderHeader={() => _renderHeader()} renderBody={() => _renderBody()} />
            {isShowModal && (
                <AddOrEditModal
                    isShowModal={isShowModal}
                    onClose={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                    }}
                    onSaveContinue={() => {
                        setIsShowModal(false);
                        _getData({ ...paging });
                    }}
                    id={selectId}
                />
            )}
        </React.Fragment>
    );
}

export default AfterEffect;
